import {observer} from "mobx-react";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {
    DialogStore,
    growlStore,
    stsCreateStore,
    stsCustomerCabinetStore,
    stsCustomerStore,
    stsZebraPrinterStore
} from "../../../store";
import {useNavigate} from "react-router";
import {useState} from "react";
import {StsCreateForm} from "./StsCreateForm";
import {PageTopperCustomerVehicleWidget} from "../../../widgets";

const StsCreatePage = observer(function StsCreatePage() {
    const navigate = useNavigate()
    const display = 'Neue Umlagerung anlegen'
    const [cancelDialog] = useState(new DialogStore())
    const [createDialog] = useState(new DialogStore())

    const saving = stsCreateStore.creating
    const formValid = stsCreateStore.valid
    const formDirty = stsCreateStore.dirty

    return <Page
        breadcrumb={[
            {
                link: '/sts',
                label: `Umlagerung`
            },
            {
                link: '/sts/create',
                label: display
            },
        ]}
        topper={<PageTopperCustomerVehicleWidget customerId={stsCreateStore.customer?.id} vin={stsCreateStore.vin} />}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        stsCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/sts')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <ModalDialog
            store={createDialog}
            actions={[
                {
                    label: "Abbrechen",
                    executing: stsCreateStore.creating,
                    execute: async function () {
                        createDialog.dialogOpen = false
                    },
                    className: 'is-rounded is-small'
                },
                {
                    label: "Anlegen",
                    executing: stsCreateStore.creating,
                    execute: async function () {
                        const id = await stsCreateStore.create()
                        if (!id) {
                            growlStore.add({
                                message: 'Die Umlagerung konnte nicht gespeichert werden',
                                autoclose: 1000,
                                cls:'is-danger',
                                closable: true
                            })
                            return
                        }
                        stsCreateStore.reset()
                        createDialog.dialogOpen = false
                        growlStore.add({
                            message: 'Die Umlagerung wurde gespeichert',
                            autoclose: 1000,
                            closable: true
                        })
                        navigate(`/sts/${id}`)

                    },
                    className: 'is-danger is-rounded is-small'
                }
            ]}
            title={"Umlagerung anlegen?"}
        >
            Sind Sie sich sicher? Ein nachträgliches Bearbeiten ist nicht möglich.
        </ModalDialog>


        <PageContentTitle
            actions={[
                {
                    label: 'Anlegen',
                    cls: `is-primary ${saving ? 'is-loading' : ''}`,
                    disabled: !(formDirty && formValid) || stsCreateStore.creating,
                    action: async () => {
                        createDialog.dialogOpen = true
                    }
                }, {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: !stsCreateStore.dirty || stsCreateStore.creating,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <StsCreateForm
            value={stsCreateStore.formData}
            disabled={stsCreateStore.creating}
            customers={stsCustomerStore.items}
            printers={stsZebraPrinterStore.options}
            cabinets={stsCustomerCabinetStore.cabinetsAsOption}
            validation={stsCreateStore.formValidation}
            onSearchCustomer={async v => await stsCustomerStore.search(v)}
            onSearchPrinter={async v => await stsZebraPrinterStore.search(v)}
            onChange={v => stsCreateStore.formData = v}
            onBlur={async () => stsCreateStore.validate()}
        />
    </Page>
})

export {
    StsCreatePage
}
